import { SectionBox } from "common/styleguide/SectionBox";
import { isEmpty } from "features/challenges/challengeUtils";
import { messages as orgChallengeMessages } from "features/organizations/OrganizationChallenges";
import { OrgContext } from "features/organizations/OrgContext";
import { useFormatMessage } from "lib/localization";
import React, { useContext } from "react";
import { defineMessages } from "react-intl";

const messages = defineMessages({
  rules: {
    id: "rules.rules",
    defaultMessage: "Rules",
  },
  emptyRules: {
    id: "rules.emptyRules",
    defaultMessage:
      "What are the rules for your Challenge? We'll show the criteria for your Challenge here and let participants know what they can and can't do.",
  },
});

export const Rules = ({ goal }) => {
  const fm = useFormatMessage();
  const { isCurrentClub } = useContext(OrgContext);

  if (isCurrentClub && isEmpty(goal, fm(orgChallengeMessages.defaultName))) {
    return <SectionBox title={fm(messages.rules)}>{fm(messages.emptyRules)}</SectionBox>;
  }

  return (
    <SectionBox title={fm(messages.rules)}>
      {goal.rules.map((r, idx) => (
        <div key={idx} style={{ marginBottom: "20px" }} dangerouslySetInnerHTML={{ __html: r }} />
      ))}
    </SectionBox>
  );
};
